import React from "react";
import PythonContent from "../function-components/learningCourses/PythonContent";

const Python = () => {
 return <PythonContent />;
};

export default Python;
